import React from 'react';
import { references } from '../mock';

function ContactRow({ label, value, href }) {
  return (
    <div>
      <p className="text-[10px] uppercase tracking-[0.3em] text-orange-acc">{label}</p>
      <a
        href={href}
        className="mt-1.5 block text-cream break-all text-sm hover:text-orange-acc transition-colors"
      >
        {value}
      </a>
    </div>
  );
}

function ReferenceCard({ index, reference }) {
  return (
    <article className="relative p-7 bg-navy-2 border border-cream group hover:border-orange-acc/60 transition-colors">
      <span className="font-display text-orange-acc text-2xl">
        {String(index + 1).padStart(2, '0')}
      </span>
      <h4 className="mt-2 font-display text-2xl md:text-3xl text-cream tracking-wide">
        {reference.name}
      </h4>
      <p className="mt-1 text-cream-soft/85 text-sm">{reference.title}</p>
      <p className="mt-1 text-cream-soft/65 text-xs uppercase tracking-[0.22em]">{reference.org}</p>
      <div className="mt-5 pt-5 border-t border-cream/15 space-y-3">
        <ContactRow label="Email" value={reference.contact} href={`mailto:${reference.contact}`} />
        {reference.phone && (
          <ContactRow
            label="Phone"
            value={reference.phone}
            href={`tel:${reference.phone.replace(/\s/g, '')}`}
          />
        )}
      </div>
    </article>
  );
}

export default function References() {
  return (
    <section id="references" className="relative py-24 md:py-32 border-t border-cream">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-12">
          <span className="font-display text-orange-acc text-2xl">03</span>
          <span className="text-[11px] uppercase tracking-[0.32em] text-cream-soft/70">References</span>
          <div className="flex-1 h-px bg-cream/20" />
        </div>

        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <h3 className="font-display text-4xl md:text-5xl text-cream">Mentors who shaped my work.</h3>
            <p className="mt-5 text-cream-soft/80 max-w-sm">
              Available on request — happy to connect for any of the projects you see here.
            </p>
          </div>
          <div className="md:col-span-8 grid sm:grid-cols-2 gap-5">
            {references.map((r, i) => (
              <ReferenceCard key={r.name} index={i} reference={r} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
